//:::::::::::::::::::::::::
import { ModelModal, Button } from 'src/_Shared/global'
//:::::::::::::::::::::::::

export default function ModalInfo(props: { clicked: () => void }) {
  return (
    <>
      <h5>{ModelModal.title}</h5>
      <p>{ModelModal.message}</p>
      <Button text={ModelModal.button} clicked={props.clicked} primary={true} />
    </>
  )
}
